import $axios from "../../api/axios";

function getLstApi({ params, callback }) {
  $axios
    .post(`/api/roomList`, params)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

function getLst2Api({ params, callback }) {
  if (params.publicFlag === 1) {
    params.data.publicFlag = 1;
  }
  $axios
    .post(`/api/housePublic/roomList/${params.propertyId}`, params.data)
    .then(res => {
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });
}

export default {
  getLstApi,
  getLst2Api
};



// WEBPACK FOOTER //
// ./src/api/dtl/price.js